import { useContent } from "./useContent";

// Used when an entry has no cover image of its own.
export const DEFAULT_CARD_IMG =
  "https://d14n4fsapeewqj.cloudfront.net/devotionals/exegesispic.webp";
export const DEFAULT_HERO_IMG =
  "https://d14n4fsapeewqj.cloudfront.net/devotionals/exegesispicturee.webp";

// Newest first. Entries with a future release date are hidden by the API.
export const useDevotionals = () => useContent("bbi", "devotionals");